jQuery( document ).ready(function() {
    initSwiper();

    function initSwiper() {
        if (jQuery(".insta-carousel-swiper").length > 0) {
            const instaCarouselSwiper = new Swiper(".insta-carousel-swiper", {
                direction: 'horizontal',
                slidesPerView: 2.2,
                spaceBetween: 12,
                freeMode: true,
                freeModeMomentum: true,
                allowTouchMove: true,
                mousewheel: {
                    forceToAxis: true,
                    invert: true
                },
                navigation: {
                    nextEl: ".insta-carousel-next",
                    prevEl: ".insta-carousel-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 12,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 18,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 18,
                    },
                    1280: {
                        slidesPerView: 5,
                        spaceBetween: 18,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 24,
                    }
                },
            });
        }
    }
})
